import { createSlice, PayloadAction, createSelector } from '@reduxjs/toolkit';
import { RootState } from 'store/store';

import { buttonEditorState } from './buttonEditorState';
import {
  ButtonEditorState,
  ButtonLayoutValue,
  DashboardButtons,
  DriverOptionsLandscapeButtons,
} from '../types';
import { ButtonScreenSection } from '../constants';

export const buttonEditorSlice = createSlice({
  name: 'buttonEditor',
  initialState: buttonEditorState,
  reducers: {
    setScreen: (state, action: PayloadAction<ButtonEditorState['screen']>) => {
      state.screen = action.payload;
    },
    setOrientation: (
      state,
      action: PayloadAction<ButtonEditorState['orientation']>,
    ) => {
      state.orientation = action.payload;
    },
    setLandscape: (
      state,
      action: PayloadAction<ButtonEditorState['landScape']>,
    ) => {
      state.landScape = action.payload;
    },
    setPortrait: (
      state,
      action: PayloadAction<ButtonEditorState['portrait']>,
    ) => {
      state.portrait = action.payload;
    },
    setWorkingLandscape: (state, action: PayloadAction<ButtonLayoutValue>) => {
      state.workingLandscape = action.payload;
    },
    setWorkingPortrait: (state, action: PayloadAction<ButtonLayoutValue>) => {
      state.workingPortrait = action.payload;
    },
    setWorkingLayoutsSeeded: (state, action: PayloadAction<boolean>) => {
      state.workingLayoutsSeeded = action.payload;
    },
    patchWorkingLayout: (
      state,
      action: PayloadAction<{
        orientation: 'landscape' | 'portrait';
        section: ButtonScreenSection;
        value: ButtonLayoutValue[ButtonScreenSection];
      }>,
    ) => {
      const layoutKey =
        action.payload.orientation === 'landscape'
          ? 'workingLandscape'
          : 'workingPortrait';

      if (action.payload.section === 'mainDashboard') {
        state[layoutKey].mainDashboard = action.payload
          .value as DashboardButtons;
      } else {
        state[layoutKey].driverOptions = action.payload
          .value as DriverOptionsLandscapeButtons;
      }
    },
    setResetData: () => buttonEditorState,
  },
});

export const { actions: buttonEditorActions } = buttonEditorSlice;

export const selectButtonEditor = (state: RootState) => state.buttonEditor;

export const selectScreen = createSelector(
  selectButtonEditor,
  buttonEditor => buttonEditor.screen,
);

export const selectOrientation = createSelector(
  selectButtonEditor,
  buttonEditor => buttonEditor.orientation,
);

export const selectLandscape = createSelector(
  selectButtonEditor,
  buttonEditor => buttonEditor.landScape,
);

export const selectPortrait = createSelector(
  selectButtonEditor,
  buttonEditor => buttonEditor.portrait,
);

export const selectWorkingLandscape = createSelector(
  selectButtonEditor,
  buttonEditor => buttonEditor.workingLandscape,
);

export const selectWorkingPortrait = createSelector(
  selectButtonEditor,
  buttonEditor => buttonEditor.workingPortrait,
);

export const selectWorkingLayoutsSeeded = createSelector(
  selectButtonEditor,
  buttonEditor => buttonEditor.workingLayoutsSeeded,
);

export default buttonEditorSlice.reducer;
